import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Input,
  ChangeDetectorRef,
  OnDestroy,
} from '@angular/core';
import { CourseService } from '@scaffold/services/course.service';
import { HttpUtilService } from '@services/http-util.service';
import { ViewModalComponent } from '@scaffold/dialogs/view-modal/view-modal.component';
import { FileMoveModalComponent } from './file-move-modal/file-move-modal.component';
import { PreviewFrameService } from '../../../tools/preview-frame/preview-frame.service';
import { UserService } from '@services/user.service';
import { RenderedService } from '../rendered.service';
import {
  ScaffoldDialogService,
  ScaffoldDialogRef,
} from '@app/framework/dialog/scaffold-dialog.service';
import { FileUploadModalComponent } from './file-upload-modal/file-upload-modal.component';
import { ConfirmDialog } from '../../../../generic/confirm-dialog/confirm-dialog.component';
import { ItemsService } from '@scaffold/services/items.service';
import { ZipService } from '@scaffold/services/zip.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TranslationService } from '@services/translation.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-filebrowser',
  templateUrl: './filebrowser.component.html',
  styleUrls: ['../rendered.component.scss', './filebrowser.component.scss'],
  standalone: false,
})
export class FilebrowserComponent implements OnInit, OnDestroy {
  @Output() selectFile = new EventEmitter<any>();
  @Input() allowSelection;
  @Input() filter;
  filters = {
    image: /(\.png$)|(\.jpe*g$)|(\.gif$)|(\.jfif)/i,
    video:
      /\.(mp4|m4v|mov|avi|mkv|webm|wmv|flv|f4v|ogv|ogg|mpg|mpeg|mpe|mp2|m2v|m4p|3gp|3g2|ts|mts|m2ts|asf|vob|rm|rmvb|divx|xvid|qt|mxf)$/i,
    doc: /.docx*$/,
    pdf: /.pdf$/,
  };
  searchParam;
  courseFileSize: number = null;
  typeFilter;
  typeFilterOptions = [];
  selectedFile;
  displayType = 'tiles';
  tiles = true;
  list = false;
  @Input() scope: string | number = 'institution';
  @Input() allowupload = false;
  @Input() readOnly = false;
  @Input() perPage = 25;

  @Input() perPageOptions = [{ count: 10 }, { count: 25 }, { count: 50 }];

  public totalFolderItems: number = 0;
  public totalFileItems: number = 0;
  creatingFolder = false;
  newFolderName;
  dialogRef: ScaffoldDialogRef;
  basefolder = { files: [], folders: [], id: undefined, type: 'courses' };
  isDownloading = false;
  public currentFolderPage: number = 1;
  public isLoadingFolders: boolean = true;
  public isLoadingFiles: boolean = true;
  public currentFilePage: number = 1;
  constructor(
    private translationService: TranslationService,
    private cdr: ChangeDetectorRef,
    private itemsService: ItemsService,
    private courseService: CourseService,
    public http: HttpUtilService,
    public dialog: ScaffoldDialogService,
    private previewFrameService: PreviewFrameService,
    private userService: UserService,
    private renderedService: RenderedService,
    private zipService: ZipService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  folder: any = new Map();
  folderstructure;
  list_items: any = {};
  terms = [];

  ngOnDestroy() {
    const urlTree = this.router.createUrlTree([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        folder: null,
        scope: null,
        term: null,
      },
      queryParamsHandling: 'merge',
    });

    this.location.replaceState(urlTree.toString());
  }

  ngOnInit() {
    console.log(this.router);
    this.typeFilterOptions = [
      {
        label: this.translationService.getTranslatedContent('any', 'Any'),
        value: '',
      },
      {
        label: this.translationService.getTranslatedContent('image', 'Image'),
        value: 'image',
      },
      {
        label: this.translationService.getTranslatedContent('document', 'Document'),
        value: 'doc',
      },
      {
        label: this.translationService.getTranslatedContent('pdf', 'PDF'),
        value: 'pdf',
      },
      {
        label: this.translationService.getTranslatedContent('video', 'Video'),
        value: 'video',
      },
    ];
    if (this.filter) {
      this.typeFilter = this.filter;
    }
    console.log('Filebrowser Open');

    // load nested folder list
    let url;
    if (this.scope === 'institution') {
      this.folderstructure = {
        id: 'institution',
        route: [],
        files: [],
        folders: [],
      };
      this.folder.set('id', 'institution');
      this.folder.set('route', []);
      this.folder.set('files', []);
      this.folder.set('folders', []);

      url = 'filefolders?output=dataonly&mode=list';
    } else {
      this.folderstructure = {
        id: this.scope,
        type: 'courses',
        route: [],
        files: [],
        folders: [],
      };
      this.folder.set('id', this.scope);
      this.folder.set('type', 'courses');
      this.folder.set('route', []);
      this.folder.set('files', []);
      this.folder.set('folders', []);
      url = 'courses/' + this.scope + '/filefolders?output=dataonly&mode=list';
      if (this.readOnly) {
        url += '&includesize=true';
      } else {
        url += '&recursive=true';
      }
    }
    this.basefolder = this.getMapData(this.folder) as any;
    for (const [key, value] of this.folder) {
      this.basefolder[key] = value;
    }

    this.courseService.get(url).subscribe(co => {
      if (co && co.listItems) {
        if (co.totalSize) {
          this.courseFileSize = Number(co.totalSize);
        }

        this.loadFolderContent(co.listItems);
        console.log(this.folderstructure);
        this.activatedRoute.queryParams.pipe(take(1)).subscribe(d => {
          console.log('Route:', d);
          if (d.folder) {
            console.log('to nav:', d.folder, this.list_items);
            if (!this.folder || this.folder.get('id') !== d.folder) {
              let toNav = this.list_items[d.folder];
              console.log('NAV Folder:', toNav);
              if (toNav) {
                Object.keys(toNav).forEach(prop => {
                  this.folder.set(prop, toNav[prop]);
                });
              } else {
                this.folder.set('id', this.scope);
                this.folder.set('type', null);
                this.folder.set('route', []);
                this.folder.set('files', []);
                this.folder.set('folders', []);
              }
            }
          } else {
            this.folder.set('id', this.scope);
            this.folder.set('type', null);
            this.folder.set('route', []);
            this.folder.set('files', []);
            this.folder.set('folders', []);
          }
          if (this.scope !== 'institution') {
            if (!this.folder) {
              this.folder.set('id', this.scope);
              this.folder.set('type', null);
              this.folder.set('route', []);
              this.folder.set('files', []);
              this.folder.set('folders', []);
            }
            this.folder.set('type', 'courses');
            if (d.term) {
              this.terms = [d.term];
            } else {
              this.terms = [];
            }
          }
          this.navigate(null, this.folder);
        });
      }
    });
  }

  displayChange(event) {
    console.log(event);
    if (event.value === 'tiles') {
      this.tiles = true;
      this.list = false;
    } else {
      this.tiles = false;
      this.list = true;
    }
  }

  openFile(e: Event, file, title?, item?) {
    e.preventDefault();
    // this.download_url = "/files/" + file;
    this.userService.isLoggedIn().subscribe(loggedIn => {
      if (loggedIn) {
        this.previewFrameService.openPreview(file, item, this.scope, title);
      }
    });
    // var win = window.open(url, '_blank');
    /*setTimeout(i => {
      this.download_url = undefined;
    },2000)*/
  }

  activePageChange($event, type) {
    if (type === 'files') {
      this.currentFilePage = $event;
      this.isLoadingFiles = true;
      this.navigate(null, this.folder, false, true, false);
    } else {
      this.isLoadingFolders = true;
      this.currentFolderPage = $event;
      this.navigate(null, this.folder, false, false, true);
    }
  }

  startZip(file) {
    const url = file.data.url || '';
    // eventually will just be an array of id already selected files/folders to work off of here, for now just a single emitted file for this method
    let destination = url
      .split('/')
      .splice(1, url.split('/').length - 1)
      .join('/');
    this.zipService.zipFiles(
      [{ url, destination, title: file.data.title }],
      [],
      this.scope
    );
  }

  startZipFolder(folder) {
    const settings: any = {
      context: {
        data: {
          title: this.translationService.getTranslatedContent(
            'zip_folder',
            'Zip Folder'
          ),
          message: `${this.translationService.getTranslatedContent('are_you_sure_you_want_to_zip', 'Are you sure you want to zip')} ${
            folder?.data?.title ||
            this.translationService.getTranslatedContent(
              'this_folder',
              'this folder'
            )
          }?`,
        },
      },
    };

    const dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      if (result) {
        this.zipService.zipFolder(folder, this.scope);
      }
    });
  }

  setPageCount(count) {
    this.perPage = count?.value || 10;
    this.navigate(null, this.folder);
  }

  search(term) {
    if (!term || term === '') {
      this.searchParam = '';
      this.terms = [];
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { term: null },
        queryParamsHandling: 'merge',
      });
    } else {
      this.terms = [term];
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { term: term },
        queryParamsHandling: 'merge',
      });
    }
    this.navigate(null, this.folder);
    this.searchParam = '';
  }

  selectFileItem(file) {
    if (this.allowSelection) {
      this.selectedFile = file;
      console.log('emiting');
      if (this.selectedFile) {
        this.selectedFile.scope = this.scope;
      }
      this.selectFile.emit(this.selectedFile);
    }
  }

  loadFolderContent(co, basefolder?) {
    console.log('Load folder content');
    const folder = this.folderstructure;
    this.list_items[folder.id] = folder;
    co.forEach((v, i) => {
      if (v) {
        this.list_items[v.id] = v;
      }
    });
    co.forEach((v, i) => {
      if (v) {
        if (this.list_items[v.parent_id]) {
          if (!this.list_items[v.parent_id].files) {
            this.list_items[v.parent_id].files = [];
            this.list_items[v.parent_id].folders = [];
          }
          v.parent = this.list_items[v.parent_id];
          if (v.type === 'files') {
            this.list_items[v.parent_id].files.push(v);
          } else {
            this.list_items[v.parent_id].folders.push(v);
          }
        } else {
          if (folder.route) {
            v.parent = folder;
          }
          if (v.type === 'files') {
            folder.files.push(v);
          } else {
            folder.folders.push(v);
          }
        }
      }
    });

    folder.folders.forEach(item => {
      this.getRoute(item);
    });

    this.cdr.markForCheck();
    console.dir(this.folderstructure);
    this.triggerUpdate('files loaded');
  }

  // checkFilter(items) {
  //   if (this.typeFilter) {
  //     const filtered = [];
  //     items.forEach((item) => {
  //       try {
  //         if (
  //           item.data.url &&
  //           item.data.url.match(this.filters[this.typeFilter])
  //         ) {
  //           filtered.push(item);
  //         }
  //       } catch (e) {
  //         console.log(e);
  //       }
  //     });

  //     return filtered;
  //   } else {
  //     return items;
  //   }
  // }

  private getRoute(item) {
    if (item.parent) {
      item.route = item.parent.route.slice();
      item.route.push(item);
    } else {
      item.route = [item];
    }
    if (item.folders) {
      item.folders.forEach(dataitem => {
        if (dataitem.type === 'filefolders') {
          this.getRoute(dataitem);
        }
      });
    }
  }

  keydown(e, folder) {
    console.log(e);
    if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') {
      this.navigate(e, folder);
    }
  }

  navigate(
    e,
    folder,
    resetPagination = true,
    getFiles = true,
    getFolders = true
  ) {
    if (folder instanceof Map) {
      let _folder = {};
      for (const [key, value] of folder) {
        _folder[key] = value;
      }
      folder = _folder;
    }
    if (!folder.id) return null;
    if (resetPagination) {
      this.currentFilePage = 1;
      this.currentFolderPage = 1;
    }
    if (e) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.preventDefault();
      this.terms = [];
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { folder: folder.id, term: null },
        queryParamsHandling: 'merge',
      });
    }

    if (getFolders && this.list_items.hasOwnProperty(folder.id)) {
      folder = this.list_items[folder.id];
    }

    if (getFiles && getFolders) {
      this.isLoadingFolders = true;
      this.isLoadingFiles = true;
      this.folder.set('id', folder.id);
      this.folder.set('type', folder.type);
      this.folder.set('route', folder.route);
      this.folder.set('files', []);
      this.folder.set('folders', []);
      this.folder.set('data', folder.data);
    } else {
      this.folder.set('id', folder.id);
      this.folder.set('type', folder.type);
      this.folder.set('route', folder.route);
      this.folder.set('folders', folder.folders);
      this.folder.set('data', folder.data);
    }

    this.selectFileItem(null);
    let folderUrl;
    let fileUrl;
    if (folder.id === 'institution') {
      folderUrl = `filefolders?output=dataonly&mode=list`;
      fileUrl = `files?output=dataonly&mode=list`;
    } else {
      folderUrl = `${folder.type}/${folder.id}/filefolders?output=dataonly&mode=list`;
      fileUrl = `${folder.type}/${folder.id}/files?output=dataonly&mode=list`;
    }
    if (this.terms?.length) {
      folderUrl +=
        '&recursive=true&searchParam=title&searchTerm=' +
        encodeURIComponent(this.terms[0]);
      fileUrl +=
        '&recursive=true&additional=filefolders&searchParam=title&searchTerm=' +
        encodeURIComponent(this.terms[0]);
    }
    folderUrl += `&pageNumber=${this.currentFolderPage - 1}&perPage=${
      this.perPage
    }`;
    fileUrl += `&pageNumber=${this.currentFilePage - 1}&perPage=${
      this.perPage
    }`;

    if (getFolders) this.getFolders(folderUrl);
    if (getFiles) this.getFiles(fileUrl);
  }

  getFolders(folderUrl) {
    this.courseService.get(folderUrl).subscribe(co => {
      console.log(co);

      if (co && co.listItems) {
        this.totalFolderItems = co?.totalItems;
        this.folder.set('folders', co.listItems);
      } else if (co.id) {
        this.totalFolderItems = 1;
        this.folder.set('folders', [co]);
      }
      if (!co) {
        this.totalFolderItems = 0;
      }

      if (co.totalItems === null || co?.listItems === null) {
        this.totalFileItems = null;
      }

      this.folder.get('folders').forEach(f => {
        if (!this.folder.get('files')) {
          this.folder.set('files', []);
          this.folder.set('folders', []);
        }
        console.log(f);
        const found = this.list_items[f.id];
        console.log('found', found);
        if (!found) {
          const item = {
            type: f.type,
            id: f.id,
            data: f.data,
            route: [...this.folder.get('route'), f],
            files: [],
            folders: [],
          };
          this.list_items[f.id] = item;
        } else {
          f.route = found.route;
        }
      });
      this.cdr.markForCheck();
      this.triggerUpdate('files loaded');
      this.isLoadingFolders = false;
    });
  }

  getFiles(fileUrl) {
    this.isLoadingFiles = true;
    if (this.typeFilter) fileUrl += `&fileType=${this.typeFilter}`;
    this.courseService.get(fileUrl).subscribe(co => {
      console.log(co);
      let filesList = [];
      if (co && co.listItems) {
        filesList = co.listItems.filter(item => item.type === 'files');
        this.totalFileItems = co.totalItems;
      } else if (co.id) {
        this.totalFileItems = co.type === 'files' ? (filesList.push(co), 1) : 0;
      }
      if (!co) {
        this.totalFileItems = 0;
      }

      this.folder.set('files', filesList);

      this.cdr.markForCheck();
      this.triggerUpdate('files loaded');
      this.isLoadingFiles = false;
    });
  }

  startCreateFolder() {
    this.creatingFolder = true;
  }

  getMapData(map) {
    let obj = {};
    for (const [key, value] of map) {
      obj[key] = value;
    }
    return obj;
  }

  startUploadFiles() {
    const config = {
      context: {
        scope: this.scope,
        folder: this.getMapData(this.folder),
      },
      closeOnBackdropClick: false,
    };
    const uploadRef = this.dialog.open(FileUploadModalComponent, config);

    uploadRef.onClose.subscribe(e => {
      if (e) {
        this.navigate(null, this.folder, false, true, false);
      }
    });
  }

  cancelFolder() {
    this.creatingFolder = false;
    this.newFolderName = '';
  }
  createFolder(folder) {
    if (folder && folder.length > 0) {
      const data: any = {
        type: 'filefolders',
        data: {
          title: folder,
        },
      };
      let path = '';
      console.log(folder);
      console.log(this.folder);
      if (this.folder.get('id') === 'institution') {
        data.data.institution = true;
      } else {
        path += '/' + this.folder.get('type') + '/' + this.folder.get('id');
      }
      path += '/filefolders';
      this.createData(path, data);
      this.creatingFolder = false;
      this.newFolderName = '';
    }
  }

  getImageUrl(item) {
    const url = 'upload/' + item.data.url;
    this.courseService.get(url).subscribe(co => {
      console.log(co);
      item.data.url = co.url;
    }); /*
    this.http.request('GET', 'https://mmvtlv572f.execute-api.us-east-2.amazonaws.com/testing/' + url, null, null, true).subscribe(co => {
      console.log(co);
      item.data.url = co.url;
    });*/
  }

  createData(path, data) {
    this.itemsService.createData(path, data).subscribe(d => {
      this.navigate(null, this.folder, false, false, true);
    });
  }

  updateData(path, data) {
    this.itemsService.saveViewData(path, { data: data }).subscribe(d => {
      this.navigate(null, this.folder);
    });
  }

  trackByIndex = (index: number): number => {
    return index;
  };

  delete(item) {
    const settings: any = {
      context: {
        data: {
          title:
            this.translationService.getTranslatedContent(
              'delete_item',
              'Delete Item'
            ) + '?',
          message:
            this.translationService.getTranslatedContent(
              'are_you_sure_you_want_to_delete_this_item',
              'Are you sure you want to delete this item'
            ) + '?',
        },
      },
    };
    const dialogRef = this.dialog.open(ConfirmDialog, settings);

    dialogRef.onClose.subscribe(result => {
      if (result) {
        const path =
          '/' +
          this.folder.get('type') +
          '/' +
          this.folder.get('id') +
          '/' +
          item.type +
          '/' +
          item.id;
        this.itemsService.deleteData(path).subscribe(d => {
          if (d?.deleted) {
            this.removeItem(item);
          }
        });
      }
    });
  }

  getType(title) {
    if (title?.match(/\.(jp.*g|png|gif|jfif)$/gi)) {
      return 'image';
    } else if (title.match(/\.(doc|rtf)$/gi)) {
      return 'doc';
    } else if (title.match(/\.(pdf)$/gi)) {
      return 'pdf';
    } else if (title.match(/\.(zip|7z|rar)$/gi)) {
      return 'zip';
    } else {
      return 'file';
    }
  }

  openMove(item) {
    if (item) {
      console.log(item);
      const config: any = {
        context: {
          data: {
            basefolder: this.folderstructure,
            folder: this.getMapData(this.folder),
          },
        },
      };
      this.dialogRef = this.dialog.open(FileMoveModalComponent, config);
      this.dialogRef.onClose.subscribe(result => {
        if (result && (result !== 'string' || result.length > 0)) {
          console.log(result);
          const path = '/' + item.type + '/' + item.id;
          this.itemsService
            .saveViewData(path, { data: { updatedParent: result.id } })
            .subscribe(d => {
              if (item.parent_id !== d.parent_id) {
                this.removeItem(d);
              }
            });
        }
      });
    }
  }

  openSettings(item) {
    console.log(item);
    const config: any = {
      context: {
        data: {
          mode: 'create',
          item: item,
        },
      },
    };
    this.dialogRef = this.dialog.open(ViewModalComponent, config);
    this.dialogRef.onClose.subscribe(result => {
      if (result && (result !== 'string' || result.length > 0)) {
        const newData = this.itemsService.getData(item);
        this.updateItem(item, newData);
      }
    });
  }

  updateItem(item, newData) {
    const type = item.type === 'filefolders' ? 'folders' : 'files';
    const items = this.folder.get(type) as [any];
    const updatedItems = items.map(_item =>
      _item.id !== item.id
        ? _item
        : { ..._item, data: { ..._item.data, ...newData } }
    );
    this.folder.set(type, updatedItems);
    this.triggerUpdate();
  }

  removeItem(item) {
    const type = item.type === 'filefolders' ? 'folders' : 'files';
    const items = this.folder.get(type) as [any];
    const updatedItems = items.filter(_item => _item.id !== item.id);
    this.folder.set(type, updatedItems);
    this.triggerUpdate();
  }
  triggerUpdate(e?) {
    console.log(e);
    try {
      this.cdr.detectChanges();
    } catch (e) {}
  }
  isDisable() {
    let disabled = this.renderedService.isDisabled('files') || this.readOnly;
    return disabled;
  }

  removeTerm(index: number) {
    this.terms.splice(index, 1);
    this.search(null);
  }
}
